var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.0002C22.732 29.0002 29 22.7322 29 15.0002C29 7.26826 22.732 1.00024 15 1.00024C7.26801 1.00024 1 7.26826 1 15.0002C1 22.7322 7.26801 29.0002 15 29.0002Z",
    fill: "url(#paint0_linear_1522_20849)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 13.2925C17.2578 13.2925 19.0881 11.4622 19.0881 9.20445C19.0881 6.94671 17.2578 5.11646 15.0001 5.11646C12.7424 5.11646 10.9121 6.94671 10.9121 9.20445C10.9121 11.4622 12.7424 13.2925 15.0001 13.2925Z",
    fill: "#DDF1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4206 20.6283V21.6643C22.4206 22.0003 22.2526 22.3363 22.0006 22.5323C17.8566 25.6403 12.1446 25.6403 8.02858 22.5323C7.74858 22.3363 7.60858 22.0003 7.60858 21.6643V20.6283C7.58058 16.5963 10.8566 13.3203 14.9166 13.3203H15.0846C19.1446 13.3203 22.4206 16.5963 22.4206 20.6283Z",
    fill: "#DDF1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_20849",
    x1: 15,
    y1: 1.00024,
    x2: 15,
    y2: 29.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535AFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlLogo);
export default __webpack_public_path__ + "static/media/dl-logo.0b2ab5bc4fbf7c76cade50a00f87e2c7.svg";
export { ForwardRef as ReactComponent };